import React, { useState, useEffect } from "react";
import QrReader from "modern-react-qr-reader";
import Grid from '@mui/material/Grid';
import { Button, Typography } from '@mui/material';
import axios from 'axios';
import swal from "sweetalert";

const QrScanReader = () => {
    const eventid = localStorage.getItem('eventid');
    // const g_id = 7;
    const [result, setResult] = useState("");
    const [facingMode, setFacingMode] = useState("environment"); 
    const handleScan = (data) => {
        if (data) {
            setResult(data);
        }
    };
    

    const handleError = (error) => {
        console.error(error);
    };
    useEffect(() => {
        if (result) {
            // Send the QR code data to the API
            sendDataToAPI(result);
        }
    }, [result]);

    const toggleCamera = () => {
        setFacingMode(prevMode => (prevMode === "user" ? "environment" : "user"));
    };

    const resetResult = () => {
        setResult('');
    };
    const sendDataToAPI = (data) => {
     
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            const sendPayload = { qrScanReaderData: data , eventid: eventid };
            axios.post(`/api/store-exhibition-qrcode-scan-data`, sendPayload,).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    console.log('Data sent to the API:', res.data);
                }

            });
        });
    };


    return (

        <>
         <Grid
            container
            spacing={2} 
            justifyContent="center" 
            alignItems="center">
            <Grid item xs={12} sm={6} md={4} lg={12} align="center"> {/* Adjust column sizes based on screen size */}
                <Typography variant="h4" sx={{ m: 2 }}>QR Code Reader</Typography>
                <QrReader
                    delay={300}
                    onError={handleError}
                    onScan={handleScan}
                    style={{ width: '100%', maxWidth: '350px' }} // Make the reader responsive
                    facingMode={facingMode} // Set facing mode based on state
                />
                {result && (
                    <div>
                        <Typography variant="h6" sx={{ m: 2 }}>Result:</Typography>
                        <Typography>ID: {result}</Typography>
                        <Button variant="contained" color="primary" onClick={resetResult}>
                            Clear Result
                        </Button>
                    </div>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={toggleCamera}
                    sx={{
                        marginTop: { xs: 2, sm: 2, md: 3, lg: 4 }, // Adjust marginTop for different screen sizes
                        width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' }, // Adjust width for different screen sizes
                    }}
                >
                    {facingMode === "user" ? "Switch to Back Camera" : "Switch to Front Camera"}
                </Button>
            </Grid>
        </Grid>
            {/* <Grid
                container
                spacing={24}
                justify="center"
                style={{ minHeight: '100vh', maxWidth: '100%' }}>
                <Grid item xs={3} align="center">
                </Grid>
                <Grid item xs={6} align="center">
                    <Typography variant="h4" sx={{ m: 2, }}>QR Code Reader</Typography>
                    <QrReader delay={300} onError={handleError} onScan={handleScan} style={{ width: '350px' }} />
                    {result && (
                        <div>
                            <Typography variant="h6" sx={{ m: 2, }}>Result:</Typography>
                            <Typography>ID: {result}</Typography>
                            <Button variant="contained" color="primary" onClick={resetResult}>
                                Clear Result
                            </Button>
                        </div>
                    )}

                </Grid>
                
            </Grid> */}
        </>
    );
}

export default QrScanReader;
